import { Routes, Route, Navigate } from 'react-router-dom';
import { AnalysisFormPage, AnalysisFlowPage } from 'pages';
import { Layout } from 'components';
import { Path } from 'utils';

export const App = () => (
  <Routes>
    <Route element={<Layout />}>
      <Route path={Path.HOME} element={<AnalysisFormPage />} />
      <Route path={Path.ANALYSIS_FLOW} element={<AnalysisFlowPage />} />
      <Route path={Path.NOT_FOUNT} element={<Navigate to={Path.HOME} replace />} />
    </Route>
  </Routes>
);
